<div class="responsive-card gap-4">
  <div i18n class="responsive-card-title">Deposit Instructions</div>
  <div *ngIf="!isWrittenCheque && !submission.paylineAccount" i18n class="subtitle">
    Payments will be deposited to the bank account listed.
  </div>

  <div *ngIf="isWrittenCheque" class="inner-card">
    <div i18n class="account-name">Written Cheque</div>
  </div>

  <div *ngIf="!isWrittenCheque && submission.bankAccount" class="inner-card d-flex flex-column gap-3">
    <div class="account-name">{{ submission.bankAccount.nickname }}</div>
    <hr class="m-0" />
    <div class="bank-info-grid">
      <app-review-entry label="Institution Number" i18n-label [value]="submission.bankAccount.institutionNumber" />
      <app-review-entry label="Transit Number" i18n-label [value]="submission.bankAccount.transitNumber" />
      <app-review-entry label="Account Number" i18n-label [value]="submission.bankAccount.accountNumber" />
    </div>
    <div i18n class="date-added">Date Added: {{ submission.bankAccount.createdDate | date : 'MMM d, y' }}</div>
  </div>

  <div *ngIf="submission.paylineAccount" class="inner-card d-flex flex-column gap-3">
    <div class="account-name" i18n>Payline {{ submission.paylineAccount.accountNumber }}</div>
    <hr class="m-0" />
    <div class="bank-info-grid">
      <app-review-entry label="Currency Type" i18n-label [value]="submission.paylineAccount.currency.name" />
      <app-review-entry label="Account Number" i18n-label [value]="submission.paylineAccount.accountNumber" />
      <app-review-entry label="Payline Bank" i18n-label [value]="submission.paylineAccount.bankName" />
    </div>
    <div i18n class="date-added">Date Added: {{ submission.paylineAccount.createdDate | date : 'MMM d, y' }}</div>
  </div>
</div>
